import Axios from 'axios'
// import { serverPath } from '../../config/path'
// Axios.defaults.baseURL = serverPath
//  跨域是否需要验证
Axios.defaults.withCredentials = true  
export default Axios


// WEBPACK FOOTER //
// ./src/api/index.js